module.exports = __webpack_public_path__ + "static/img/leaves_256.b8104a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leaves_256.png
// module id = WqH/
// module chunks = 0